module.exports = __webpack_public_path__ + "static/media/HDFC_Mutual_Fund.c5de07a8.pdf";